import styles from './copy-id.module.css';

import { Badge } from '@radix-ui/themes';
import { Ref } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  id: string;
  badgeRef: Ref<HTMLSpanElement>;
  onCopy: () => void;
  copied: boolean;
  coords: { x: number; y: number } | null;
  tooltipContainer: HTMLElement | null;
}

export default function CopyID({
  id,
  badgeRef,
  onCopy,
  copied,
  coords,
  tooltipContainer
}: Props) {
  return (
    <>
      <Badge
        ref={badgeRef}
        color='gold'
        onClick={onCopy}
        style={{ cursor: 'pointer' }}
      >
        #{id}
      </Badge>
      {copied && coords && tooltipContainer
        ? createPortal(
            <div
              className={styles.Tooltip}
              style={{
                top: `${coords.y}px`,
                left: `${coords.x}px`
              }}
            >
              Скопировано!
            </div>,
            tooltipContainer
          )
        : null}
    </>
  );
}
